module.exports = __webpack_public_path__ + "static/media/search.72b7fc36.svg";